'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Divider;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Divider(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react2.default.createElement('div', {
    role: 'separator',
    style: style,
    className: (0, _classnames2.default)(className, 'rrui__divider')
  }, _react2.default.createElement('hr', {
    className: 'rrui__divider__line'
  }));
} // Workaround for `react-hot-loader`.
// https://github.com/gaearon/react-hot-loader#checking-element-types


Divider.displayName = 'Divider';